<template>
    <div class="product-list-container">
        <div class="product-grid">
            <div class="product-item" v-for="(product, index) in products" :key="index"
                @click="goToProduct(product)">
                <div class="product-image-wrapper">
                    <img :src="product.image" :alt="product.name" class="product-image">
                    <div class="new-tag" v-if="product.isNew">新品</div>
                </div>
                <div class="product-name">{{ product.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductList',
    props: {
        top: {
            type: [Number, String],
            default: 70
        }
    },
    data() {
        return {
            products: []
        }
    },
    async created() {
        try {
            const response = await this.$http.get('cms/content/front-list', {
                params: {
                    pageNum: 1,
                    pageSize: 10,
                    catalogId: '636455896526917' // 使用您的实际产品目录ID
                }
            })

            if (!response.data) {
                console.log('响应中没有data字段')
                return
            }

            const rows = response.data.rows || []
            console.log("rowsrowsrowsrowsrows",rows)

            if (rows.length === 0) {
                console.log('没有产品数据')
                return
            }
            this.products = rows.map(item => ({
                name: item.title,
                image: item.logoSrc,
                isNew: item.isNew || false,
                contentId: item.contentId
            }))

        } catch (error) {
            console.error('获取产品数据失败:', error)
            this.products = []
        }
    },
    methods: {
        goToProduct(product) {
            console.log('点击产品:', product)
            try {
                this.$router.push({
                    path: '/product',
                    query: {
                        id: product.contentId
                    }
                }).catch(err => {
                    console.error('路由跳转失败:', err)
                })
            } catch (error) {
                console.error('跳转方法执行失败:', error)
            }
        }
    }
}

</script>

<style scoped>
.product-list-container {
    width: 100%;
    padding: 40px 0;
    background-color: #ffffff;
    background: #ffffff;
    z-index: 1000;
    position: relative;
    top: v-bind(top + 'px');
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.product-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    transition: background-color 0.3s ease;
    padding: 10px;
    border-radius: 8px;
}

.product-item:hover {
    background-color: #F5F6F7;
}

.product-image-wrapper {
    position: relative;
    width: 100%;
    /* aspect-ratio: 1; */
    /* border: 1px dashed #ccc; */
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
}

.product-image {
    max-width: 80%;
    max-height: 229px;
    object-fit: contain;
}

.new-tag {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #4CAF50;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
}

.product-name {
    font-size: 16px;
    color: #333;
    text-align: center;
}

@media screen and (max-width: 768px) {
    .product-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        padding: 0 15px;
    }

    .product-name {
        font-size: 14px;
    }
}
</style> 